module.exports = __webpack_public_path__ + "img/10_39.306b9645.png";